import React, { useState, useEffect } from 'react';
import ModalDefault from '../../ModalDefault';
import ButtonDefault from '../../form/ButtonDefault';
import { IconClose } from '../../icons';
import { ModalWrapper, ModalTitle, ModalButtons } from '../../../pages/Demanda/styles';
import styled from 'styled-components';

const TextareaContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    label {
        font-size: 14px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.interfaceText400};
    }

    textarea {
        width: 100%;
        max-width: 100%;
        min-height: 120px;
        padding: 12px;
        border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
        border-radius: 6px;
        font-size: 14px;
        font-family: inherit;
        resize: vertical;
        transition: border-color 0.2s;
        box-sizing: border-box;

        &:focus {
            outline: none;
            border-color: ${({ theme }) => theme.colors.primaryRed400};
        }

        &::placeholder {
            color: ${({ theme }) => theme.colors.interfaceText200};
        }
    }

    .error {
        color: ${({ theme }) => theme.colors.primaryRed400};
        font-size: 12px;
        margin-top: 4px;
    }
`;

interface ModalRecusarDemandaProps {
    modalAtivo: boolean;
    setModalAtivo: (ativo: boolean) => void;
    onConfirmar: (justificativa: string) => void;
    loading?: boolean;
}

export default function ModalRecusarDemanda({ 
    modalAtivo, 
    setModalAtivo, 
    onConfirmar,
    loading = false 
}: ModalRecusarDemandaProps) {
    const [justificativa, setJustificativa] = useState('');
    const [erro, setErro] = useState('');

    useEffect(() => {
        if (modalAtivo) {
            setJustificativa('');
            setErro('');
        }
    }, [modalAtivo]);

    const handleConfirmar = () => {
        const justificativaTrimmed = justificativa.trim();
        
        if (!justificativaTrimmed) {
            setErro('A justificativa é obrigatória');
            return;
        }

        setErro('');
        onConfirmar(justificativaTrimmed);
    };

    const handleCancelar = () => {
        setJustificativa('');
        setErro('');
        setModalAtivo(false);
    };

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setJustificativa(e.target.value);
        if (erro && e.target.value.trim()) {
            setErro('');
        }
    };

    return (
        <ModalDefault
            id={'overlayModal'}
            onClose={handleCancelar}
            openModal={modalAtivo}
            width="520px"
        >
            <ModalWrapper>
                <ModalTitle>
                    <div className="points">
                        Recusar Demanda
                    </div>
                    <div
                        className="close"
                        onClick={handleCancelar}
                    >
                        <IconClose />
                    </div>
                </ModalTitle>

                <div className="accept">
                    <p>Ao recusar a demanda, você será desassociado dela e a recusa será registrada com a justificativa informada.</p>
                    
                    <TextareaContainer>
                        <label>
                            Justificativa <span style={{ color: 'var(--ce52940)' }}>*</span>
                        </label>
                        <textarea
                            placeholder="Informe o motivo da recusa da demanda..."
                            value={justificativa}
                            onChange={handleChange}
                            disabled={loading}
                        />
                        {erro && <div className="error">{erro}</div>}
                    </TextareaContainer>
                </div>

                <ModalButtons>
                    <ButtonDefault
                        className="cancel"
                        onClick={handleCancelar}
                        disabled={loading}
                    >
                        Cancelar
                    </ButtonDefault>
                    <ButtonDefault
                        className="continue"
                        onClick={handleConfirmar}
                        disabled={loading || !justificativa.trim()}
                    >
                        {loading ? 'Processando...' : 'Confirmar'}
                    </ButtonDefault>
                </ModalButtons>
            </ModalWrapper>
        </ModalDefault>
    );
}

